import PropTypes from "prop-types";
import classNames from "classnames";
import React, { useState, useEffect, useRef } from "react";
import "./_style.scss";

const TextareaAutosize = (props) => {
  const {
    append,
    disabled,
    rows,
    name,
    onBlur,
    onChange,
    onFocus,
    className,
    placeholder,
    valid,
    initialValue,
    value: valueProp,
  } = props;
  const textareaRef = useRef(null);

  const [value, setValue] = useState(initialValue ?? valueProp ?? "");

  // Sync internal state when a controlled value is reset from outside
  useEffect(() => {
    if (valueProp !== undefined && valueProp !== value) {
      setValue(valueProp);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueProp]);

  const textAreaChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = `${scrollHeight}px`;
    }
  }, [value]);

  /* eslint react/no-unknown-property: "off" */
  return (
    <textarea
      ref={textareaRef}
      append={append}
      disabled={disabled}
      rows={rows}
      name={name}
      onBlur={onBlur}
      onChange={textAreaChange}
      onFocus={onFocus}
      placeholder={placeholder}
      valid={valid}
      className={classNames(className, "textareaautosize")}
      value={value}
    />
  );
};

TextareaAutosize.propTypes = {
  onBlur: PropTypes.func.isRequired,
};

export default TextareaAutosize;
